import { render, staticRenderFns } from "./NodeComponent.vue?vue&type=template&id=1648b024&scoped=true&"
import script from "./NodeComponent.vue?vue&type=script&lang=ts&"
export * from "./NodeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./NodeComponent.vue?vue&type=style&index=0&id=1648b024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648b024",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDivider,VSimpleTable})
